import { render, staticRenderFns } from "./addressWrongPayDialog.vue?vue&type=template&id=216cb06c&scoped=true"
import script from "./addressWrongPayDialog.vue?vue&type=script&lang=js"
export * from "./addressWrongPayDialog.vue?vue&type=script&lang=js"
import style0 from "./addressWrongPayDialog.vue?vue&type=style&index=0&id=216cb06c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216cb06c",
  null
  
)

export default component.exports